var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:hotel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.708252 13.4583V2.83334H2.12492V9.91668H7.79158V4.25001H13.4583C14.2374 4.25001 14.9044 4.52744 15.4593 5.0823C16.0142 5.63716 16.2916 6.30418 16.2916 7.08334V13.4583H14.8749V11.3333H2.12492V13.4583H0.708252ZM4.95825 9.20834C4.36797 9.20834 3.86624 9.00175 3.45304 8.58855C3.03985 8.17536 2.83325 7.67362 2.83325 7.08334C2.83325 6.49307 3.03985 5.99133 3.45304 5.57814C3.86624 5.16494 4.36797 4.95834 4.95825 4.95834C5.54853 4.95834 6.05027 5.16494 6.46346 5.57814C6.87665 5.99133 7.08325 6.49307 7.08325 7.08334C7.08325 7.67362 6.87665 8.17536 6.46346 8.58855C6.05027 9.00175 5.54853 9.20834 4.95825 9.20834Z",
    fill: "#27346A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.a36f9b3ce4b2eff23eb6ee43be559aaa.svg";
export { ForwardRef as ReactComponent };